import { FC } from 'react'
import { useHistory } from 'react-router-dom'

import './styles.scss'

interface NotificationsProps {
  hasNotifications?: boolean
}

const Notifications: FC<NotificationsProps> = ({
  hasNotifications = false
}) => {
  const history = useHistory()

  return (
    <div className='ui-notifications'>
      <span
        className='mdi mdi-bell-outline ui-notifications-bell'
        onClick={() =>
          history.push('/notifications', {
            prevPage: history.location.pathname
          })
        }
      >
        {hasNotifications && <span className='ui-notifications-badge'></span>}
      </span>
    </div>
  )
}

export default Notifications
